import React from 'react';
import { useSticker, ShapeType, SHAPE_IMAGES } from '../../context/StickerContext';
import { useToast } from '../ui/Toast';
const SHAPES: ShapeType[] = ['Circle', 'Square', 'Oval', 'Die Cut', 'Rounded Corners', 'Rectangle'];
export function ShapePanel() {
  const {
    shape,
    setShape
  } = useSticker();
  const {
    addToast
  } = useToast();
  const handleSelect = (s: ShapeType) => {
    setShape(s);
    addToast('Updating shape...');
  };
  return <div className="h-full flex flex-col" data-id="element-275">
      <div className="p-4 border-b border-gray-100" data-id="element-276">
        <h2 className="font-semibold text-[#111111]" data-id="element-277">Shape</h2>
      </div>
      <div className="p-4 overflow-y-auto flex-1" data-id="element-278">
        <div className="grid grid-cols-2 gap-3" data-id="element-279">
          {SHAPES.map(s => {
          const isSelected = shape === s;
          return <button key={s} onClick={() => handleSelect(s)} className={`relative rounded-xl border-2 transition-all text-center ${isSelected ? 'border-[#008696] ring-2 ring-[#EAF6F7] bg-[#EAF6F7]' : 'border-[#D9D9D9] hover:border-gray-400 bg-gray-100'}`} data-id="element-280">
                <div className="px-2 pt-2 pb-1" data-id="element-281">
                  <img src={SHAPE_IMAGES[s]} alt={s} className="w-full h-20 object-contain drop-shadow-sm" onError={e => {
                ;
                (e.target as HTMLImageElement).style.display = 'none';
              }} data-id="element-282" />
                </div>
                <div className={`px-2 py-1.5 text-xs font-semibold ${isSelected ? 'text-[#008696]' : 'text-[#5F5F5F]'}`} data-id="element-283">
                  {s}
                </div>
              </button>;
        })}
        </div>
        {shape === 'Die Cut' && <p className="text-xs text-[#008696] bg-[#EAF6F7] rounded-lg px-3 py-2 mt-4" data-id="element-284">
            Die Cut stickers are cut to the exact outline of your uploaded
            artwork.
          </p>}
        <div className="mt-6 pt-4 border-t border-gray-100" data-id="element-285">
          <p className="text-xs font-semibold text-[#5F5F5F] uppercase tracking-wide mb-2" data-id="element-286">
            Included
          </p>
          <div className="space-y-1.5 text-xs text-[#5F5F5F]" data-id="element-287">
            <div className="flex items-center gap-2" data-id="element-288">
              <span className="w-1.5 h-1.5 rounded-full bg-[#008696]" data-id="element-289" />
              Finish: Gloss
            </div>
            <div className="flex items-center gap-2" data-id="element-290">
              <span className="w-1.5 h-1.5 rounded-full bg-[#008696]" data-id="element-291" />
              Material: 4.3 mil air release vinyl
            </div>
            <div className="flex items-center gap-2" data-id="element-292">
              <span className="w-1.5 h-1.5 rounded-full bg-[#008696]" data-id="element-293" />
              Eco-solvent printed
            </div>
          </div>
        </div>
      </div>
    </div>;
}